import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function SquareUnlockStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M6.75 9V6.5C6.75 3.60051 9.10051 1.25 12 1.25C14.3356 1.25 16.0042 2.76166 16.707 4.75C16.8451 5.14051 16.6405 5.56896 16.25 5.70703C15.8595 5.84507 15.431 5.64049 15.293 5.25C14.7602 3.7428 13.583 2.75 12 2.75C9.92893 2.75 8.25 4.42893 8.25 6.5V9C8.25 9.41421 7.91421 9.75 7.5 9.75C7.08579 9.75 6.75 9.41421 6.75 9Z"
				fill="currentColor"
			/>
			<path
				d="M19.2502 11C19.2502 10.3097 18.6905 9.7501 18.0002 9.75H6.00024C5.30989 9.75001 4.75025 10.3096 4.75024 11L4.75122 20C4.75128 20.6903 5.3109 21.25 6.00122 21.25H18.0002C18.6905 21.2499 19.2502 20.6903 19.2502 20V11ZM20.7502 20C20.7502 21.5188 19.519 22.7499 18.0002 22.75H6.00122C4.48254 22.75 3.25136 21.5187 3.25122 20L3.25024 11C3.25025 9.48123 4.48145 8.25001 6.00024 8.25H18.0002C19.519 8.2501 20.7502 9.48128 20.7502 11V20Z"
				fill="currentColor"
			/>
			<path
				d="M11.25 16.5V14.5C11.25 14.0858 11.5858 13.75 12 13.75C12.4142 13.75 12.75 14.0858 12.75 14.5V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

SquareUnlockStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default SquareUnlockStrokeIcon;
